import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Apoio from "../views/Apoio.vue";
import Ajuda from "../views/Ajuda.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Apoio,
  },
  {
    path: "/apoio",
    component: Apoio,
  },
  {
    path: "/ajuda",
    component: Ajuda,
  },
  {
    path: "/boletim",
    component: Home,
  },
  {
    path: "/bole",
    component: Home,
  },
  {
    path: "/coord",
    component: Home,
  },
  {
    path: "/coordenador",
    component: Home,
  },
  {
    path: "/relatorio",
    component: Home,
  },
  {
    path: "/rel",
    component: Home,
  },
  {
    path: "*",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
